import React from 'react';
import ScrollAnimation from 'react-animate-on-scroll';
import { headerSolutionsItems } from '../../data/data';
import { Link, useHistory } from 'react-router-dom';

const NoctilSolutions = () => {
  const history = useHistory();
  return (
    <div className="container noctil-solutions">
      <div className="pt--60">
        <div className="row">
          <div className="col-lg-12 text-center">
            <ScrollAnimation animateIn="fadeInUp" animateOnce={true} delay={50}>
              <h2>Explore Our Solutions</h2>
            </ScrollAnimation>
          </div>
        </div>
        <div className="grid-center-cols--3">
          {headerSolutionsItems.map(({ icon, title, url }, idx) => (
            <div
              className={`text-center solution-block mb--10 ${
                idx === headerSolutionsItems.length - 1 && 'mt--50'
              }`}
              onClick={() => history.push(url)}
            >
              <div className="solution-content">
                <ScrollAnimation animateIn="fadeInUp" animateOnce={true} delay={50}>
                  <div>
                    <img src={'/assets/images/' + icon} alt={title} />
                  </div>
                  <p>
                    <Link className="font--18" to={url}>
                      {title === 'Custom Portal'
                        ? 'Custom Portal for Rightsholder'
                        : title}
                    </Link>
                  </p>
                </ScrollAnimation>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default NoctilSolutions;
